module.exports = __webpack_public_path__ + "img/kursy.d2b5a806.svg";